// extracted by mini-css-extract-plugin
module.exports = {"inputSmall":"date-module--inputSmall--3VrFF","inputLarge":"date-module--inputLarge--2v28B"};